exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".time-ticker---1Cam4{display:block;font-weight:bold}.inactivity-image---3EgKV{height:200px;display:block;margin:0 auto 10px}.timeout-image---3t1Kx{padding:26px 18px;width:220px;display:block}", ""]);

// exports
exports.locals = {
	"time-ticker": "time-ticker---1Cam4",
	"inactivity-image": "inactivity-image---3EgKV",
	"timeout-image": "timeout-image---3t1Kx"
};